/* @flow */

export const baseStyleId = 'base-style';
